import dashLogo from "../../assets/images/sidebarIcon/lightDashboard.png";

import dashDark from "../../assets/images/sidebarIcon/dashDark.png";
import courseLogo from "../../assets/images/sidebarIcon/lightCourse.png";
import darkCourse from "../../assets/images/sidebarIcon/darkCourse.png";
import darkSupport from "../../assets/images/sidebarIcon/darkSupport.png";
import lightSupport from "../../assets/images/sidebarIcon/lightSupport.png";

export const SidebarData = [
  {
    title: "Dashboard",
    path: "/client-admin/dashboard",
    activeTab: ["/client-admin/dashboard"],
    icon: dashLogo,
    activeIcon: dashDark,
    moduleName: null,
  },
  {
    title: "Course",
    path: "/client-admin/courses",
    activeTab: ["/client-admin/courses"],
    icon: courseLogo,
    activeIcon: darkCourse,
    moduleName: null,
  },
  {
    title: "Report",
    path: "/client-admin/reports/master-reports",
    activeTab: ["/client-admin/reports/master-reports"],
    icon: dashLogo,
    activeIcon: dashDark,
    moduleName: null,
  },
  {
    title: "Support",
    path: "/assessment-quizz-management",
    activeTab: [
      "/assessment-quizz-management",
      "/add-assessment-quizz",
      "/interactive-quizz-management",
      "/add-interactive-quizz",
      "/add-free-quizz",
    ],
    icon: lightSupport,
    activeIcon: darkSupport,
    moduleName: null,
    key: ["interactive_quiz", "assessment_quiz"],
    subMenu: [
      {
        label: "Raise a Ticket",
      },
      {
        label: "Chat With Us",
      },
      {
        label: "OnBoarding Guide",
      },
    ],
  },
];
